import _ from 'lodash';


function getIndividualLinks(links) {
  return links.filter(({ groupName }) => !groupName);
}

function createLinkGroups(links) {
  return links.reduce((linkGroups, link) => {
    const { groupName } = link;
    if (groupName) {
      return {
        ...linkGroups,
        [groupName]: linkGroups[groupName]
          ? [...linkGroups[groupName], link]
          : [link]
      }
    }

    return linkGroups
  }, {})
}

function linksToGroupOfLinks(individualLinks, groupedLinks) {
  return [...individualLinks, ..._.values(groupedLinks)].map(linkOrGroup => {
    if(_.isArray(linkOrGroup)) {
      const firstGroupItem = linkOrGroup[0];
      const { groupName, navigationPriority } = firstGroupItem;
      return {
        navigationPriority,
        title: groupName,
        links: linkOrGroup
      }
    }

    return linkOrGroup;
  })
}

export function sortLinks(links) {
  // Sorts by navigationPriority and remove that property
  return _.sortBy(links, ['navigationPriority']);
}

export function cleanLinkProps(links) {
  return links.map(({navigationPriority, groupName, ...link}) => link);
}


export function transformLinks(links) {
  return links.map(link => {
    const { props, ...rest } = link;

    if (props) {
      return { ...JSON.parse(props), ...rest }
    }

    return rest;
  })
}

export function groupLinks(links) {
  const transformedLinks = transformLinks(links);
  const individualLinks = getIndividualLinks(transformedLinks);
  const linkGroups = createLinkGroups(transformedLinks);
  const mergedLinks = linksToGroupOfLinks(individualLinks, linkGroups);
  const sortedLinks = sortLinks(mergedLinks);
  const cleanedLinks = cleanLinkProps(sortedLinks);
  return cleanedLinks;
}
